import spartaMediaQueryUtility from '@sparta.global.utilities/sparta-mediaquery-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import spartaSqueezeboxUtility from '@sparta.global.utilities/sparta-squeezebox-utility/dist/es6.js';
import spartaStickyUtility from '@sparta.global.utilities/sparta-sticky-utility/dist/es6.js';
import $ from '@sparta.global.vendors/jquery';
import Handlebars from '@sparta.global.vendors/handlebars';
import { getObjectValue } from '@sparta.sb-credit-cards.helpers/sb-credit-cards/dist/es6.js';
import { compare } from '@sparta.global.helpers/comparisons-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " header-style-override ";
},"3":function(container,depth0,helpers,partials,data) {
    return "negative-margins";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(helpers,"lookup").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"module") : depth0),"headerPartialName",{"name":"lookup","hash":{},"data":data,"loc":{"start":{"line":11,"column":19},"end":{"line":11,"column":54}}}),depth0,{"data":data,"indent":"                ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"7":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                <h2 class=\"heading\r\n                "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"title-position") : stack1),"==","center",{"name":"compare","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":14,"column":16},"end":{"line":14,"column":88}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"title-position") : stack1),"==","right",{"name":"compare","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":16},"end":{"line":15,"column":87}}})) != null ? stack1 : "")
    + "\r\n                "
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"headerRemoved") : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":16,"column":16},"end":{"line":16,"column":83}}})) != null ? stack1 : "")
    + "\">\r\n                  "
    + ((stack1 = (lookupProperty(helpers,"getObjectValue")||(depth0 && lookupProperty(depth0,"getObjectValue"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"titles") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1),{"name":"getObjectValue","hash":{},"data":data,"loc":{"start":{"line":17,"column":18},"end":{"line":17,"column":70}}})) != null ? stack1 : "")
    + "\r\n                </h2>\r\n";
},"8":function(container,depth0,helpers,partials,data) {
    return " text-center";
},"10":function(container,depth0,helpers,partials,data) {
    return " text-right";
},"12":function(container,depth0,helpers,partials,data) {
    return " hide-header";
},"14":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "                    "
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\r\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"row small-collapse"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"headerStyleOverride") : stack1),"==",true,{"name":"compare","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":30},"end":{"line":1,"column":114}}})) != null ? stack1 : "")
    + "\">\r\n  <div class=\"column small-12\">\r\n    <section class=\"squeezebox-wrapper\" data-squeezebox-type\r\n      id=\"collapsibleSqueezeboxWrapper-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\">\r\n      <div class=\"squeezebox-panels\">\r\n        <div class=\"squeezebox-panel active "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"negativeColumnMargins") : stack1),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":44},"end":{"line":6,"column":103}}})) != null ? stack1 : "")
    + "\"\r\n          id=\"collSectionPanel1-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\">\r\n          <div class=\"row collapse\">\r\n            <div class=\"column small-12 large-10 large-centered\">\r\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"headerPartialName") : stack1),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.program(7, data, 0),"data":data,"loc":{"start":{"line":10,"column":14},"end":{"line":19,"column":21}}})) != null ? stack1 : "")
    + "              <a href=\"javascript:void(0);\" class=\"panel-header spa-oline transparent-background\"\r\n                data-panel=\"collSectionPanel1-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\" id=\"collSectionPanel1link-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\"\r\n                role=\"application\">\r\n                <span class=\"spa-squeezebox-arrow spa-icon hide-for-medium-up\"></span>\r\n                <h2 class=\"heading show-for-small-only\">\r\n                  "
    + ((stack1 = (lookupProperty(helpers,"getObjectValue")||(depth0 && lookupProperty(depth0,"getObjectValue"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"data1") : depth0)) != null ? lookupProperty(stack1,"titles") : stack1),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1),{"name":"getObjectValue","hash":{},"data":data,"loc":{"start":{"line":25,"column":18},"end":{"line":25,"column":70}}})) != null ? stack1 : "")
    + "\r\n                </h2>\r\n              </a>\r\n            </div>\r\n          </div>\r\n          <div class=\"panel-content transparent-background\" aria-labelledby=\"collSectionTab1-"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"containerID") : stack1), depth0))
    + "\">\r\n            <div class=\"content\">\r\n              <div class=\"row\">\r\n                <div class=\"column small-12\" class=\"collapsibleSectionChildModulesDepositsContainer\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"children") : depth0),{"name":"each","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":34,"column":18},"end":{"line":36,"column":27}}})) != null ? stack1 : "")
    + "                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n  </div>\r\n</div>\r\n";
},"usePartial":true,"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/collapsible-section-sbcc-module",
  "version": "2.0.1",
  "id": "collapsibleSectionSbccModule",
  "containerID": "sbCreditCardsCollapsibleSectionSbccModule",
  "moduleName": "sb-credit-cards-collapsible-section-sbcc-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "collapsible-section-sbcc-module",
  "data": {
    "init": "collapsibleSectionSbccModuleJS",
    "options": {}
  },
  "moduleParams": [{
    "name": "headerPartialName",
    "type": "string",
    "default": "",
    "description": "Partial name to load instead of default header"
  }, {
    "name": "headerRemoved",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Removed the header added by this module and let the child module set its own header"
  }, {
    "name": "headerStyleOverride",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Use boolean value to latch onto with handlebars logic to add a class to the parent container that would style the components header differently when needed"
  }, {
    "name": "lastCollapsibleSection",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Added to initialize the accordion utility after all sections have loaded."
  }, {
    "name": "negativeColumnMargins",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Add negative left/right 10px margins."
  }, {
    "name": "title-position",
    "type": "string",
    "values": ["left", "center", "right"],
    "default": "left",
    "description": "Positions the title in the middle, left, or right"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        getObjectValue,
        compare
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    getObjectValue,
    compare
  },
  "dependencies": {
    "@sparta.sb-credit-cards.helpers/sb-credit-cards": "^2.0.0",
    "@sparta.global.helpers/comparisons-helper": "^1.0.0",
    "@sparta.global.helpers/squeezebox-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-mediaquery-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-squeezebox-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-sticky-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * @export
 * @class collapsibleSectionSbccModuleJS
 * @extends {Module}
 */
class collapsibleSectionSbccModuleJS extends Module {
  /**
  * Creates an instance
  * @param {object} options options
  * @param {object} context context
  */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.target = this.settings.target;
  }

  /**
   * @return {void}
   * @memberof collapsibleSectionSbccModuleJS
   */
  init() {
    // Accordion
    const accordionEls = this.settings.target.querySelectorAll('.squeezebox-panel');
    if (!accordionEls || !accordionEls.length) {
      return;
    }
    const accordionEl = accordionEls[0];
    const currentMQ = this.Store.getData('currentMQ');

    // Open panel on medium-up by default.
    if (currentMQ.mediaQueries['small-only'] !== true) {
      spartaSqueezeboxUtility.setActiveState(accordionEl, true);
    } else {
      spartaSqueezeboxUtility.setActiveState(accordionEl, false);
    }

    // Open/close panel based on media queries.
    this.Events.sub(spartaMediaQueryUtility.EVENTS.BREAKPOINT_CHANGE, e => {
      const panelIsOpen = e.data.mediaQueries['small-only'] !== true;
      spartaSqueezeboxUtility.setActiveState(accordionEl, panelIsOpen);
    });
    [spartaSqueezeboxUtility.EVENTS.SQUEEZEBOX_ITEM_HIDE, spartaSqueezeboxUtility.EVENTS.SQUEEZEBOX_ITEM_SHOW].forEach(event => {
      this.Events.sub(event, () => {
        setTimeout(() => {
          spartaStickyUtility.recalcStickyEls();
        }, 1e3);
      });
    });
    if (this.params.lastCollapsibleSection) {
      spartaSqueezeboxUtility.init();
    }
    this.toggleArrow();
    setTimeout(() => {
      spartaSqueezeboxUtility.init();
    }, 0);
  }

  /**
   * Toggle accordion arrow down on
   * @returns {undefined} Rendered markup.
   */
  toggleArrow() {
    const $target = $(this.settings.target);
    $target.find('[data-panel]').each(function f1() {
      const $panelSpan = $(this).find('> span');
      $(this).on('click', event => {
        event.preventDefault();
        $panelSpan.toggleClass('active');
      });
    });
  }
}
registerModuleClass({
  moduleClass: collapsibleSectionSbccModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { collapsibleSectionSbccModuleJS as default, moduleConfig };
